export const CREATE_NEW_CHAT_CONVERSATION_FAILURE = 'CREATE_NEW_CHAT_CONVERSATION_FAILURE';

export const createNewChatConversationFailure = error => ({
    type: CREATE_NEW_CHAT_CONVERSATION_FAILURE,
    payload: error,
    error: true,
});
